<form
[formGroup]="form"
class="animated fadeIn fast"
appCapslockOn
(capslockOn)="capslockOn = $event"
[class.mt-10]="anyAlert() || loading"
appBlockCopyPaste
>
  <app-loading *ngIf="loading"></app-loading>
  <app-alert *ngIf="capslockOn" [alert]="capslock"></app-alert>
  <app-alert *ngIf="error" [alert]="error"></app-alert>
  <div *ngIf="!loading" class="animated fadeIn fast">
    <div class="row">
      <div class="col-lg-12">
        <h4 class="subtitle primary">Ingresa los datos del administrador</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div
          class="form-group"
          [class.has-error]="helpers.invalidControl(form.get('firstName'))"
        >
          <label class="label-form" for="firstName">Nombre</label>
          <input
            type="text"
            maxlength="20"
            class="form-control"
            formControlName="firstName"
          />
          <span
            class="help-block invalid-feedback"
            *ngIf="helpers.invalidControl(form.get('firstName'))"
          >
            <span *ngIf="form.get('firstName').errors.required">{{
              constants.validations.required.message
            }}</span>
            <span *ngIf="form.get('firstName').errors.pattern">{{
              constants.validations.alphabetic.message
            }}</span>
          </span>
        </div>
      </div>
      <div class="col-md-6">
        <div
          class="form-group"
          [class.has-error]="helpers.invalidControl(form.get('lastName'))"
        >
          <label class="label-form" for="lastName">Apellidos</label>
          <input
            type="text"
            maxlength="20"
            class="form-control"
            formControlName="lastName"
          />
          <span
            class="help-block invalid-feedback"
            *ngIf="helpers.invalidControl(form.get('lastName'))"
          >
            <span *ngIf="form.get('lastName').errors.required">{{
              constants.validations.required.message
            }}</span>
            <span *ngIf="form.get('lastName').errors.pattern">{{
              constants.validations.alphabetic.message
            }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div
          class="form-group has-feedback"
          [class.has-error]="helpers.invalidControl(form.get('docType'))"
        >
          <label class="label-form" for="docType">Tipo de documento</label>
          <select
            class="form-control"
            formControlName="docType"
            (change)="onChange($event)"
          >
            <option value="" disabled selected>Seleccione</option>
            <option *ngFor="let type of docTypes" value="{{ type.value }}">
              {{ type.name }}
            </option>
          </select>
          <i
            class="glyphicon glyphicon-menu-down form-control-feedback custom-select-arrow"
          ></i>
          <span
            class="help-block invalid-feedback"
            *ngIf="helpers.invalidControl(form.get('docType'))"
          >
            {{ constants.validations.required.message }}
          </span>
        </div>
      </div>
      <div class="col-md-6">
        <div
          class="form-group"
          [class.has-error]="helpers.invalidControl(form.get('docNumber'))"
        >
          <label class="label-form" for="docNumber">Número de documento</label>
          <input
            type="text"
            class="form-control"
            formControlName="docNumber"
            [maxlength]="maxLengthDoc"
            mask="0*"
          />
          <span
            class="help-block invalid-feedback"
            *ngIf="helpers.invalidControl(form.get('docNumber'))"
          >
            <span *ngIf="form.get('docNumber').errors.required">{{
              constants.validations.required.message
            }}</span>
            <span
              *ngIf="
                form.get('docNumber').errors.pattern ||
                form.get('docNumber').errors.maxlength ||
                form.get('docNumber').errors.minlength
              "
              >{{
                constants.validations.docNumber.message(
                  form.get("docNumber").errors.minlength?.requiredLength || maxLengthDoc
                )
              }}</span
            >
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div
          class="form-group"
          [class.has-error]="helpers.invalidControl(form.get('email'))"
        >
          <label class="label-form" for="email">Correo</label>
          <input
            type="text"
            class="form-control"
            maxlength="60"
            formControlName="email"
          />
          <span
            class="help-block invalid-feedback"
            *ngIf="helpers.invalidControl(form.get('email'))"
          >
            <span *ngIf="form.get('email').errors.required">{{
              constants.validations.required.message
            }}</span>
            <span *ngIf="form.get('email').errors.pattern">{{
              constants.validations.email.message
            }}</span>
          </span>
        </div>
      </div>
      <div class="col-md-6">
        <div
          class="form-group"
          [class.has-error]="helpers.invalidControl(form.get('charge'))"
        >
          <label class="label-form" for="charge">Cargo</label>
          <input
            type="text"
            maxlength="60"
            class="form-control"
            formControlName="charge"
          />
          <span
            class="help-block invalid-feedback"
            *ngIf="helpers.invalidControl(form.get('charge'))"
          >
            <span *ngIf="form.get('charge').errors.required">{{
              constants.validations.required.message
            }}</span>
            <span *ngIf="form.get('charge').errors.pattern">{{
              constants.validations.alphabetic.message
            }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div
          class="form-group"
          [class.has-error]="helpers.invalidControl(form.get('phone'))"
        >
          <label class="label-form" for="phone">Teléfono</label>
          <input
            type="text"
            class="form-control"
            formControlName="phone"
            prefix="+51 9 "
            mask="0*"
            [validation]="true"
            maxlength="14"
            (click)="onClickImputTel($event)"
            (keyup)="onClickImputTel($event)"
          />
          <span
            class="help-block invalid-feedback"
            *ngIf="helpers.invalidControl(form.get('phone'))"
          >
            <span *ngIf="form.get('phone').errors.required">{{
              constants.validations.required.message
            }}</span>
            <span *ngIf="form.get('phone').errors.minlength">{{
              constants.validations.invalidPhone.message
            }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 mt-15">
        <div class="form-group">
          <div class="row">
            <div class="col-md-1">
              <div class="container-check" (click)="toggleTerms()">
                <input type="checkbox" formControlName="terms" />
                <span class="checkmark"></span>
              </div>
            </div>
            <div class="col-md-11">
              <a class="label-form primary pointer" download="Documentos" href="assets/terms.zip" for="terms">
                Acepto los términos y condiciones.
              </a>
              <p class="label-form secondary" for="terms">
                Declaro estar en conocimiento y aceptar las condiciones.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!loading" class="row text-center">
    <button
      type="button"
      (click)="create()"
      [disabled]="form.invalid || loading"
      class="button-continue button-find-label"
    >
      Crear cuenta
    </button>
  </div>
  <div *ngIf="!loading" class="row text-center">
    <a class="primary green-link pointer" appBackButton>Volver ></a>
  </div>
</form>
